import React from 'react';
import './about.css';
import terminal from '../../img/terminal.png';
import { FaHtml5, FaCss3, FaNodeJs } from "react-icons/fa";
import { IoLogoJavascript, IoLogoReact } from "react-icons/io5";
import { SiExpress, SiMongodb, SiFirebase, SiTypescript, SiJava, SiGit, SiGithub, SiFigma, SiTailwindcss } from "react-icons/si";

const About = () => {
    return (
        <div className="a">
            <p className="a-tag">WHO AM I?</p>
            <h1 className="a-title">About Me</h1>
            <div className="a-desc">
                <img src={terminal} className="terminal" alt="" />

                <p className="description">
                    Hi there! My name is Sachin karun, and I'm passionate about creating applications that are efficient and intuitive for users. I'm constantly learning and exploring new technologies in order to stay ahead of the competition and keep up with the ever-changing web development landscape. If you're looking for a web developer who's up to date on the latest trends and technologies, please feel free to reach out. I'm confident that I can help you achieve your web development goals.
                </p>
            </div>

            <p className="tools">Tools & Technologies</p>
            <div className="boxes">
                <div className="box">
                    <ul>
                        <li>
                            <FaHtml5 className="a-icon"/> HTML & CSS
                        </li>
                        <li><IoLogoJavascript className="a-icon"/> JavaScript</li>
                        <li><IoLogoReact className="a-icon"/> React</li>
                        <li><IoLogoReact className="a-icon"/> React Native</li>
                    </ul>
                </div>
                <div className="box">
                    <ul>
                    <li><FaNodeJs className="a-icon"/> NodeJS</li>
                        <li><SiExpress className="a-icon"/> ExpressJS</li>
                        <li><SiMongodb className="a-icon"/> MongoDB</li>
                        <li><SiFirebase className="a-icon"/> Firebase</li>
                    </ul>
                </div>
                <div className="box">
                    <ul>
                        <li><SiJava className="a-icon"/> Java</li>
                        <li><SiGit className="a-icon"/> Git</li>
                        <li><SiGithub className="a-icon"/> Github</li>
                        <li><SiFigma className="a-icon"/> Figma</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default About
